import React from "react";

const Projects = () => {
  const projects = [
    { title: "Solonet Properties", desc: "Premium real estate developments in Ghana." },
    { title: "Ice Chest Mineral Water", desc: "Quality bottled water for homes and businesses." },
    { title: "Global Timber Ltd", desc: "Exporting high-quality timber products to Asia." },
  ];

  return (
    <section id="projects" className="projects">
      <h2>My Ventures</h2>
      <div className="project-list">
        {projects.map((p, index) => (
          <div className="project-card" key={index}>
            <h3>{p.title}</h3>
            <p>{p.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Projects;
